export default __webpack_public_path__ + "static/media/client4.81b5afa2.svg";